import React from 'react';
import { useSelector } from 'react-redux';
import { startDateModStyles } from './StartDateMod.styles';
import { Grid, Typography } from '@mui/material';
import {
  selectCurrentModDetails,
  selectInitiators,
  selectIsEditMod,
  selectStartDateReasonCodes,
} from 'store/redux-store/placement-mods/selectors';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { NewStartDate } from './NewStartDate';
import { NewPreEmploymentDate } from './NewPreEmploymentDate';
import { StartDateReasonCode } from './StartDateReasonCode';
import { InitiatedBy } from './InitiatedBy';
import { KeepConstant } from './KeepConstant';
import { NewEndDate } from './NewEndDate';

export const StartDateMod = () => {
  const { t } = useTranslation();
  const { classes } = startDateModStyles();
  const selectedModsDetails = useSelector(selectCurrentModDetails);
  const reasonCodes = useSelector(selectStartDateReasonCodes);
  const initiators = useSelector(selectInitiators);
  const isModEdit = useSelector(selectIsEditMod);

  return (
    <>
      <Grid>
        <Grid className={classes.labelRow}>
          <Typography component="span" className={classes.labelFont}>{`${t(
            'placement.placementMods.currentStartDate',
          )}`}</Typography>
          <Typography component="span">
            {selectedModsDetails?.currentStartDate
              ? moment(selectedModsDetails?.currentStartDate)?.format('MM/DD/YYYY')
              : '--'}
          </Typography>
        </Grid>
        <Grid className={classes.labelRow}>
          <Typography component="span" className={classes.labelFont}>{`${t(
            'placement.placementMods.currentEndDate',
          )}`}</Typography>
          <Typography component="span">
            {selectedModsDetails?.currentStartDate
              ? moment(selectedModsDetails?.currentEndDate)?.format('MM/DD/YYYY')
              : '--'}
          </Typography>
        </Grid>
        <Grid className={classes.labelRow}>
          <Typography component="span" className={classes.labelFont}>{`${t(
            'placement.placementMods.currentPreEmploymentDate',
          )}`}</Typography>
          <Typography component="span">
            {selectedModsDetails?.currentPreEmploymentDate
              ? moment(selectedModsDetails?.currentPreEmploymentDate)?.format('MM/DD/YYYY')
              : '--'}
          </Typography>
        </Grid>
        <NewEndDate></NewEndDate>
        <div className={classes.root}>
          <Grid container spacing={4} className={classes.gridContainer}>
            <Grid item xs={12} className={classes.dateContainer}>
              <NewStartDate isModEdit={isModEdit} />
            </Grid>
            <Grid item xs={12} className={classes.dateContainer}>
              <NewPreEmploymentDate isModEdit={isModEdit} />
            </Grid>
            {reasonCodes && (
              <Grid item xs={12} className={classes.dateContainer}>
                <StartDateReasonCode options={reasonCodes} isModEdit={isModEdit} />
              </Grid>
            )}
            <Grid item xs={12} className={classes.dateContainer}>
              <InitiatedBy options={initiators} isModEdit={isModEdit} />
            </Grid>
            <Grid item xs={12}>
              <KeepConstant isModEdit={isModEdit} />
            </Grid>
          </Grid>
        </div>
      </Grid>
    </>
  );
};
